<template>
	<div class="header">
						<p class="name">早上好XX，欢迎使用系统</p>
						<div class="right">
							<div class="search">
								<img src="@/assets/search_03.jpg" />
								<input type="text" placeholder="请输入搜索内容" name="" id="" value="" />
							</div>
							<div class="icon">
								<a href="#"><img src="@/assets/home1.png" /></a>
							</div>
							<div class="icon on">
								<a href="#"><img src="@/assets/home.png" /></a>
							</div>
							<div class="user">
								<a href="#">
									<img src="@/assets/home6.png" class="is" />
								</a>
							</div>
						</div>
					</div>
</template>

<script>
	export default {
		name: 'navbars',
		data() {
			return {
				handleOpen(key, keyPath) {
					console.log(key, keyPath);
				},
				handleClose(key, keyPath) {
					console.log(key, keyPath);
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	 .header {
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: #F2F7FF;
	padding-right: 20px;
	padding-left: 265px;
	z-index: 1;
	height: 100px;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

 .header .name {
	font-size: 14px;
	color: #888EB1;
}

 .header .right {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

 .header .right .user {
	width: 41px;
	height: 41px;
	border-radius: 50%;
	position: relative;
	cursor: pointer;
	margin-left: 13px;
}

 .header .right .user .is {
	width: 100%;
	height: 100%;
}

 .header .right .icon {
	width: 40px;
	height: 40px;
	background: #FEFEFF;
	margin-right: 20px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
}

 .header .right .icon.on::after {
	content: '';
	border-radius: 50%;
	position: absolute;
	width: 4px;
	height: 4px;
	background: #FF0000;
	right: 10px;
	top: 7px;
}

 .header .right .search {
	width: 6.46rem;
	height: 50px;
	margin-right: .88rem;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #CED8F4;
}

 .header .right .search img {
	display: block;
}

 .header .right .search input {
	flex: 1;
	height: 100%;
	border: none;
	outline: none;
	background: none;
	font-size: 14px;
	color: #BCC8DF;
	padding-left: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/headers.vue